import "./ThankYou.css";

function isWhatsAppGroupUrl(value) {
  try {
    const url = new URL(String(value || "").trim());

    return (
      url.protocol === "https:" &&
      url.hostname.toLowerCase() === "chat.whatsapp.com"
    );
  } catch (error) {
    return false;
  }
}

function WhatsAppIcon() {
  return (
    <i className="fa-brands fa-whatsapp lp-thank-you-whatsapp-icon" aria-hidden="true" />
  );
}

function ReminderIcon() {
  return (
    <span className="lp-thank-you-reminder-icon" aria-hidden="true">
      <i className="fa-solid fa-calendar lp-thank-you-calendar-icon" />
      <i className="fa-solid fa-clock lp-thank-you-clock-icon" />
    </span>
  );
}

function GroupArrow() {
  return (
    <span className="lp-thank-you-link-arrow" aria-hidden="true">
      <svg viewBox="0 0 24 24" focusable="false">
        <path d="m15 5-7 7 7 7" />
      </svg>
    </span>
  );
}

function ThankYou({ whatsappGroupUrl = "" }) {
  const safeGroupUrl = isWhatsAppGroupUrl(whatsappGroupUrl)
    ? String(whatsappGroupUrl).trim()
    : "";

  return (
    <main className="lp-thank-you">
      <section className="lp-thank-you-content" aria-live="polite">
        <div className="lp-thank-you-badge" aria-hidden="true">
          <svg className="lp-thank-you-check" viewBox="0 0 48 48" focusable="false">
            <path className="lp-thank-you-check-path" d="M11 25.5 20.5 35 37 14" />
          </svg>
        </div>
        <h1 className="lp-thank-you-title">تم تسجيلك بنجاح</h1>
        <p className="lp-thank-you-message">
          شكرا لك، تم حجز مكانك في اللقاء. ستصلك رسالة تأكيد على بريدك
          الإلكتروني خلال دقائق.
        </p>
        <div className="lp-thank-you-group-area">
          <ReminderIcon />
          <p className="lp-thank-you-note">
            لتصلك تذكيرات اللقاء
            <br />
            للواتساب
          </p>
          {safeGroupUrl ? (
            <a
              className="lp-thank-you-group-link"
              href={safeGroupUrl}
              rel="noopener noreferrer"
              target="_blank"
            >
              <WhatsAppIcon />
              <span>انضم لمجموعة الواتساب</span>
              <GroupArrow />
            </a>
          ) : (
            <button
              className="lp-thank-you-group-link lp-thank-you-group-link--pending"
              aria-label="انضم لمجموعة الواتساب"
              disabled
              title="سيتم تفعيل الرابط قريباً"
              type="button"
            >
              <WhatsAppIcon />
              <span>انضم لمجموعة الواتساب</span>
              <GroupArrow />
            </button>
          )}
        </div>
      </section>
    </main>
  );
}

export default ThankYou;
